import { render, staticRenderFns } from "./account-tab.vue?vue&type=template&id=2fccc80b"
import script from "./account-tab.vue?vue&type=script&lang=js"
export * from "./account-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports